import { REACT_APP_NODE_ENV } from '../environment';
import { ModuleIdMappingProd } from './modules.prod';
import { ModuleIdMappingQa } from './modules.qa';
import { ModuleIdMappingUat } from './modules.uat';

export const ModuleConstants = {
  ...(process.env?.[REACT_APP_NODE_ENV] === 'production'
    ? ModuleIdMappingProd
    : process.env?.[REACT_APP_NODE_ENV] === 'uat'
      ? ModuleIdMappingUat
      : ModuleIdMappingQa),
};
